import styled, { css } from 'styled-components';

import { black, grey400, greenLightest2 } from 'styles/colors';

export const Container = styled.div`
	color: ${black};
	font-size: 16px;
	display: flex;
	width: 100%;
	flex-direction: column;

	${({ selectedFilter }) =>
		selectedFilter &&
		css`
			overflow: hidden;
		`};
`;

export const List = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 24px;
`;

export const Row = styled.div`
	display: flex;
	font-size: 16px;
	font-weight: 400;
	letter-spacing: 0.3px;
	line-height: 27px;
	padding: 8px 32px;
`;

export const FilterRow = styled(Row)`
	transition: background-color 100ms ease-out;
	cursor: pointer;

	&:hover {
		background-color: ${greenLightest2};
	}
`;

export const BackRow = styled(Row)`
	cursor: pointer;
	padding-top: 16px;
`;

export const FiltersContainer = styled.div`
	transition: 0.5s;
	display: flex;
	flex-direction: column;
	width: 100%;
	overflow: hidden;
`;

export const FilterLabel = styled.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	flex-grow: 1;
	color: ${black};
	${({ active }) => (active ? `font-weight: 700;` : '')};
`;

export const FilterIconWrapper = styled.div`
	display: flex;
	align-items: center;
	color: ${grey400};
`;
